import { render } from "./ChapterButton.vue?vue&type=template&id=4a022526&scoped=true"
import script from "./ChapterButton.vue?vue&type=script&lang=js"
export * from "./ChapterButton.vue?vue&type=script&lang=js"

import "./ChapterButton.vue?vue&type=style&index=0&id=4a022526&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-4a022526"

export default script